import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import ApiNames from "../constants/ApiNames";
import { encode as base64_encode } from "base-64";
import { fetchGet } from "../utils/FetchApi";
import Awareness from "../components/Awareness";
import tagManagerEvents from "../utils/GoogleTagManager";
import TagManager from "react-gtm-module";
import { setCookie } from "../utils/CommonFunction";

const AwarenessScreen = (props) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const utm_source = searchParams.get("utm_source")
    ? searchParams.get("utm_source")
    : "";
  useEffect(() => {
    if (props.token) {
      getFlow();
    }
  }, [props.token]);
  useEffect(() => {
    setTimeout(() => {
      gtmInitialization();
    }, 1000);
  }, []);
  const gtmInitialization = () => {
    const tagManagerArgs = {
      gtmId: "GTM-5TH9GVH",
    };
    TagManager.initialize(tagManagerArgs);
  };

  const getFlow = async () => {
    try {
      var endpoint = `${ApiNames.awarenessFlow}`;
      endpoint = endpoint + "?utm_source=" + utm_source;
      let response = await fetchGet(endpoint, props.token);

      if (
        response.status === 208 &&
        response.response.desc.toLowerCase() ===
          "subscriber subscribed successfully"
      ) {
        tagManagerEvents("subscribe", "econTikTok");
        navigateToHome(
          response.response.msisdn.slice(-10),
          response.response.token,
          response.response.subscribeId
        );
      } else if (
        response.status === 208 &&
        response.response.desc.toLowerCase() === "already subscribed"
      ) {
        navigateToHome(
          response.response.msisdn.slice(-10),
          response.response.token,
          response.response.subscribeId
        );
      } else {
        navigateToLanding();
      }
    } catch (error) {
      navigateToLanding();
    }
  };
  const navigateToLanding = () => {
    let url = window.location.origin;
    url = `${url}/landing`;
    window.location.replace(url);
  };

  const navigateToHome = (msisdn, token, subscribeId) => {
    let url = window.location.origin;
    setCookie(msisdn, token, subscribeId);
    url = `${url}/home`;
    if (url.includes("http:")) {
      url = url.replace("http", "https");
    }
    window.location.replace(url);
  };

  return <Awareness />;
};

export default AwarenessScreen;
